import { render, staticRenderFns } from "./authorizeBrandAction.vue?vue&type=template&id=65835f5c&scoped=true"
import script from "./authorizeBrandAction.vue?vue&type=script&lang=js"
export * from "./authorizeBrandAction.vue?vue&type=script&lang=js"
import style0 from "./authorizeBrandAction.vue?vue&type=style&index=0&id=65835f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65835f5c",
  null
  
)

export default component.exports